import React, { useState } from "react";
import { Plus, Minus, MessagesSquare } from "lucide-react";
import { useCMS, useSectionEnabled } from "../context/CMSContext";

export default function FAQ() {
  const enabled = useSectionEnabled("faq");
  const { cms } = useCMS();
  const [open, setOpen] = useState(0);
  if (!enabled) return null;
  const faqs = cms?.faqs || [];

  return (
    <section id="faq" className="bg-white py-16 sm:py-20">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-[1fr_1.4fr] gap-10 lg:gap-12 items-start">
          <div className="lg:sticky lg:top-24">
            <span className="lm-chip-accent inline-block px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider">
              FAQ
            </span>
            <h2 className="lm-section-title text-2xl sm:text-4xl lg:text-[44px] mt-4 leading-tight">
              Got Questions? <span className="lm-underline-swoosh">We've Got Answers</span>
            </h2>
            <p className="text-[#11151C]/65 mt-4 text-base sm:text-lg">
              Everything you need to know about our hosting services. Can't find what you're looking for? Reach out to our support team.
            </p>
            <div className="mt-6 inline-flex items-center gap-3 lm-card p-4">
              <span className="w-10 h-10 lm-icon-tile inline-flex items-center justify-center">
                <MessagesSquare className="w-5 h-5" />
              </span>
              <div>
                <div className="font-bold text-[#11151C] text-sm">24/7 Support</div>
                <div className="text-[#11151C]/60 text-xs">Always here to help</div>
              </div>
            </div>
          </div>

          <div className="space-y-3">
            {faqs.map((f, i) => {
              const isOpen = open === i;
              return (
                <button
                  key={f.q}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className={`w-full text-left lm-card p-5 ${isOpen ? "border-[#FF6B3D]/30" : ""}`}
                >
                  <div className="flex items-start gap-3 sm:gap-4">
                    <span className="lm-font font-extrabold text-[#FF6B3D] text-sm mt-1">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <div className="flex-1">
                      <div className="flex items-center justify-between gap-3 sm:gap-4">
                        <h4 className="lm-font font-bold text-[#11151C] text-base sm:text-lg">{f.q}</h4>
                        <span className="w-8 h-8 rounded-full bg-[#FFE6D6] flex items-center justify-center flex-shrink-0">
                          {isOpen ? (
                            <Minus className="w-4 h-4 text-[#B23B12]" />
                          ) : (
                            <Plus className="w-4 h-4 text-[#B23B12]" />
                          )}
                        </span>
                      </div>
                      {isOpen && (
                        <p className="mt-3 text-[#11151C]/70 text-sm leading-relaxed">{f.a}</p>
                      )}
                    </div>
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
